// extracted by mini-css-extract-plugin
module.exports = {"card_section":"card-section_card_section__qld9X","header":"card-section_header__1EI6V","title":"card-section_title__3yhe5"};